import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { Tab } from "@headlessui/react";
import { Modifier } from "./Modifier";
import { Language } from "./Language";
import "../Settings/setting.css";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export const ModifierMain = () => {
    const { t } = useTranslation();
    const {catId, slug} = useParams();
    const [itemId, setLocation] = useState(catId || "");

    const { modifiers, modifier, loading, restaurants,
        checked_restaurants, all_future_locations, is_all_restaurants} = useSelector(({ modifiers }) => ({
        loading: modifiers.loading,
        modifiers: modifiers.modifiers,
        modifier: modifiers.modifier,
        restaurants: modifiers.restaurants,
        checked_restaurants: modifiers.modifier.checked_restaurants,
        all_future_locations: modifiers.modifier.all_future_locations,
        is_all_restaurants: modifiers.modifier.is_all_restaurants,
    }));

    const props = {
        loading, modifiers, modifier, itemId, slug, restaurants, checked_restaurants,
        all_future_locations, is_all_restaurants}

    const tabs = [
        {
            name: `${t("General")}`,
            component: <Modifier {...props}/>,
        },
        {
            name: `${t("Language")}`,
            component: <Language {...props}/>,
        },
    ];

    return (
        <div className="max-w-screen-xl px-2 sm:px-0 mt-7 mx-11">
            <Tab.Group>
                <Tab.List className="flex max-w-sm rounded-lg shadow-md bg-gray-100">
                    {tabs.map(({ name }) => (
                        <Tab
                            key={name}
                            className={({ selected }) =>
                                classNames(
                                    "w-full first:rounded-l-2xl tabs p-2 leading-5 text-xs font-medium",
                                    "ring-white font-extrabold focus:outline-none",
                                    selected
                                        ? "bg-purple-500 f shadow-xl hover:text-white text-white"
                                        : "text-black-700 hover:bg-indigo-100"
                                )
                            }
                        >
                            {name}
                        </Tab>
                    ))}
                </Tab.List>
                <Tab.Panels className="mt-2 py-1 bg-white ">
                    {tabs.map((tab, idx) => (
                        <Tab.Panel
                            key={idx}
                            className={classNames(
                                "bg-white focus:outline-none"
                            )}
                        >
                            {tab.component}
                        </Tab.Panel>
                    ))}
                </Tab.Panels>
            </Tab.Group>
        </div>
    );
};

